import { render, staticRenderFns } from "./Reset-Password.vue?vue&type=template&id=745905fc&scoped=true&"
import script from "./Reset-Password.vue?vue&type=script&lang=js&"
export * from "./Reset-Password.vue?vue&type=script&lang=js&"
import style0 from "./Reset-Password.vue?vue&type=style&index=0&id=745905fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745905fc",
  null
  
)

export default component.exports